<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SKYBMF/tc-custom/9781609943431.jpg?1703426607467" alt="This image is the cover for the book Expanding Our Now"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Expanding Our Now
      </h1>
      <p class="bookDescription body article font2">
        <p>At the start of this thoughtful and revelatory book, Harrison Owen relates the story of how he was lunching with a senior official of the American Society for Training and Development, who observed that if what Owen had just told him about Open Space Technology (OST) was true, then "95% of what we are currently doing does not need to be done." OST is strategy for organizing meetings that is radical, revolutionary, and deceptively simple. Expanding Our Now is an exploration of what OST is, how it developed as a process for meeting management, and how and why it works all over the world, for groups of all sizes dealing with a vast range of issues. To be published simultaneously with Open Space Technology: A User's Guide, -- a companion volume which details methods for implementing an Open Space event -- Expanding Our Now provides historical background, with case studies and delves into the questions of why and how Open Space works. Owen makes a compelling case that OST can move organizations to higher levels of performance, without elaborate training or professional facilitators. By focusing on 'Now' -- this present moment -- perception is expanded so that, for example, AT&amp;T was able to accomplish 10 months work in a matter of 2 days. 'Now' is the heart of the matter. When Now gets big, time and space open up for doing what is needed. In the experience of Owen and thousands of people around the world who have used this technology successfully, OST expands 'Now' . Here he offers numerous successful case studies from corporations (such as Boeing and AT&amp;T), community service organizations, and even countries (Canada) to demonstrate the power of 'Now'. While Open Space violates many of the traditional principles of meeting (and organizational) management, it is remarkably effective. Owen challenges the idea that anyone can actually control a closed system, suggesting that in reality all systems are open, and OST simply acknowledges and takes full advantage of that reality.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harrison H Owen
      </h2>
      
      <p class="authorDescription body article">Harrison H. Owen</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b8300a6c